"use client";

import { TAGS_LISTING_API } from "@/lib/constants";
import { TTagListing } from "@/types/tags";
import { useQuery } from "@tanstack/react-query";
import TagCard from "../tag-card";
import CategoriesLoadingState from "@/modules/categories/components/category-listing/categories-loading-state";

async function getTagListingData() {
	const res = await fetch(TAGS_LISTING_API, { next: { revalidate: 10 } });

	if (!res.ok) {
		const { message } = await res.json();
		throw new Error(message);
	}

	const { data } = (await res.json()) as { data: TTagListing[] };

	return data;
}

const TagListing = () => {
	const {
		isLoading,
		isError,
		data: tagsList = [],
	} = useQuery({ queryKey: ["tagsList"], queryFn: getTagListingData });

	return (
		<>
			{isLoading ? (
				<CategoriesLoadingState />
			) : isError ? (
				<div className="py-4">
					<span className="text-gray-600">Something went wrong. Could not load categories.</span>
				</div>
			) : (
				<div className="grid grid-cols-1 gap-8 pb-16 lg:grid-cols-3">
					{tagsList.map((tag) =>
						tag.products?.length > 0 ? <TagCard key={tag.id} tag={tag} /> : null
					)}
				</div>
			)}
		</>
	);
};

export default TagListing;
